(function($) {
  // 注意: WishlistHelperはwishlist_helper.jsから読み込まれます（このファイルより前に読み込む必要があります）
  // ユーザーのウィッシュリストを取得し、コールバックを使用して最初のリストIDを取得
  function fetchUserWishlists(onSuccess, onError) {
    const onSuccessCallback = function(data) {
      const lists = WishlistHelper.parseResponseData(data, ['lists']);

      if (lists && lists.length > 0) {
        // 最初のウィッシュリスト（またはデフォルトのウィッシュリスト）を取得
        const defaultList = lists.find(list => list.isDefault) || lists.find(list => list.default) || lists[0];
        const lid = defaultList.lid || defaultList.id || defaultList.listId;
        if (onSuccess) onSuccess(lid);
      } else {
        if (onError) onError('No wishlists found');
      }
    };
    
    const onErrorCallback = function(error) {
      console.error('ユーザーのウィッシュリストの取得エラー:', error);
      if (onError) onError(error);
    };
    
    _swat.wishlist.fetchUserLists(onSuccessCallback, onErrorCallback);
  }

  // リストIDを使用してコールバックでリストコンテンツを取得
  function fetchListContents(lid, onSuccess, onError) {
    // リスト設定を定義
    let listConfig = {
      "lid": lid
    };
    
    const onSuccessCallback = function(listContents) {
      const items = WishlistHelper.parseResponseData(listContents, ['items', 'products']);
      
      if (items && items.length > 0) {
        if (onSuccess) onSuccess(items);
      } else {
        if (onError) onError('No items found');
      }
    };
    
    const onErrorCallback = function(error) {
      console.error('リストコンテンツの取得エラー:', error);
      if (onError) onError(error);
    };
    
    _swat.fetchListCtx(listConfig, onSuccessCallback, onErrorCallback);
  }

  // 冗長なAPI呼び出しを避けるための商品詳細のキャッシュ
  // 注意: 価格が更新される可能性があるため、キャッシュは短時間のみ有効
  const productCache = new Map();
  const CACHE_DURATION = 5 * 60 * 1000; // 5分間キャッシュ

  // 商品ハンドルを使用してShopifyから商品詳細を取得（キャッシュ付き）
  async function fetchProductDetails(handle, forceRefresh = false) {
    if (!handle) return null;
    
    // キャッシュを確認（強制リフレッシュでない場合）
    if (!forceRefresh && productCache.has(handle)) {
      const cached = productCache.get(handle);
      const now = Date.now();
      // キャッシュが有効期限内であれば使用
      if (cached.timestamp && (now - cached.timestamp) < CACHE_DURATION) {
        return cached.data;
      }
      // キャッシュが期限切れの場合は削除
      productCache.delete(handle);
    }
    
    try {
      const response = await $.ajax({
        url: `/products/${handle}.js`,
        dataType: 'json'
      });
      
      // レスポンスをタイムスタンプ付きでキャッシュ
      if (response) {
        productCache.set(handle, {
          data: response,
          timestamp: Date.now()
        });
      }
      
      return response;
    } catch (error) {
      console.error('商品詳細の取得エラー:', error);
      return null;
    }
  }

  // バリアントIDとハンドルを使用してShopifyから最新の価格を取得
  async function fetchVariantPrice(variantId, handle) {
    if (!variantId || !handle) return null;
    
    try {
      // 商品詳細を取得（価格更新を確実にするため、キャッシュを無視）
      const product = await fetchProductDetails(handle, true);
      if (!product || !product.variants) return null;
      
      // variantIdを数値に変換（SwymのvariantIdは数値形式）
      const numericVariantId = typeof variantId === 'string' 
        ? parseInt(variantId.replace(/[^0-9]/g, '')) 
        : variantId;
      
      // 該当するバリアントを検索
      // Shopify variant IDは数値形式（例: 123456789）または文字列形式（例: "gid://shopify/ProductVariant/123456789"）
      const variant = product.variants.find(v => {
        let vId;
        if (typeof v.id === 'string') {
          // GID形式または数値文字列の場合
          const match = v.id.match(/\d+/);
          vId = match ? parseInt(match[0]) : parseInt(v.id.replace(/[^0-9]/g, ''));
        } else {
          vId = v.id;
        }
        return vId === numericVariantId;
      });
      
      if (variant && variant.price) {
        // Shopify APIは価格をcents（100分の1単位）で返すため、100で割って円単位に変換
        const priceInCents = typeof variant.price === 'number' 
          ? variant.price 
          : parseFloat(variant.price) || 0;
        // 100で割って円単位に変換
        return priceInCents / 100;
      }
      
      return null;
    } catch (error) {
      console.error('バリアント価格の取得エラー:', error);
      return null;
    }
  }

  // バリアントIDでバリアントが売り切れかどうかを確認（product.liquidのcurrent_variant.inventory_quantityチェックと同様）
  async function checkVariantAvailability(variantId, productHandle) {
    if (!variantId) return null; 
    const variants = await Product.getVariants(productHandle);
    
    // variantIdを数値に変換
    const numericVariantId = typeof variantId === 'string' 
      ? parseInt(variantId.replace(/[^0-9]/g, '')) 
      : variantId;
    
    // GraphQL APIはGID形式で返すため、数値部分を比較
    const variant = variants.find(v => {
      if (!v || !v.id) return false;
      // GID形式から数値を抽出（例: "gid://shopify/ProductVariant/123456789"）
      const match = v.id.toString().match(/\d+/);
      const vId = match ? parseInt(match[0]) : null;
      return vId === numericVariantId;
    });
    
    const preorderList = Globo?.Preorder?.settings?.preorderSettings?.products || {};
    if (variant?.currentlyNotInStock || !variant?.availableForSale){
      const isPreOrder = Object.values(preorderList).some(obj => obj.hasOwnProperty(variantId));
      if (isPreOrder) {
        return 'preorder'; 
      }
      return 'soldout';
    }
    return 'available';
  }

  // Shopifyから商品メタ情報（locationとstore_name）を取得
  async function getProductMeta(productId) {
    try {
      if (typeof Product !== 'undefined' && Product.getProductWithMeta) {
        const result = await Product.getProductWithMeta(productId);
        if (result && result.product) {
          const metafields = result.product.metafields || [];
          // nullやundefinedの要素をフィルタリングしてから検索
          const validMetafields = metafields.filter(m => m != null && typeof m === 'object' && m.key);
          const location = validMetafields.find(m => m.key === 'location')?.value || null;
          const store_name = validMetafields.find(m => m.key === 'store_name')?.value || null;
          return { location, store_name };
        }
      }
      return { location: null, store_name: null };
    } catch (error) {
      console.error('商品メタ情報の取得エラー:', error);
      return { location: null, store_name: null };
    }
  }

  // ロケーション文字列をフォーマット
  function formatLocation(location, store_name) {
    if (!location) return '';
    let locationText = location;
    if (store_name) {
      locationText += '/' + store_name;
    }
    return locationText;
  }

  // Swymアイテムデータから商品カードをレンダリング
  function renderProductCard(swymItem, metaData = null, isSoldOut = 'available', latestPrice = null) {
    // Swymアイテム構造からデータを抽出
    const imageUrl = swymItem.iu || swymItem.product?.iu || '';
    // 最新の価格が提供されている場合はそれを使用、なければSwymの価格をフォールバック
    let price;
    if (latestPrice !== null) {
      // latestPriceは既にyen単位（fetchVariantPriceで100で割られている）
      price = latestPrice;
    } else {
      // Swymの価格もShopifyと同様にcentsで保存されているため、100で割ってyen単位に変換
      const swymPrice = swymItem.pr || swymItem.product?.pr || 0;
      price = swymPrice > 0 ? swymPrice / 100 : 0;
    }
    // 元のURLを保存（Swym APIで削除する際に必要）
    const originalProductUrl = swymItem.product?.du || swymItem['raw-du'] || swymItem.du || '';
    let productUrl = originalProductUrl;
    const variantInfo = swymItem.vi || '';
    // variantIdを取得（epiはSwymのvariant ID、数値形式）
    const variantId = swymItem.epi || swymItem.product?.epi || '';
    const itemId = swymItem.id || '';
    const lid = swymItem.lid || '';
    const productId = swymItem.empi || swymItem.product?.empi || '';
    const productTitle = swymItem.dt || swymItem.product?.dt || "";
    const variantTitle = swymItem.vi || "";
    const title = variantTitle ? `${productTitle} - ${variantTitle}` : productTitle;
    // URLから商品ハンドルを解析
    let handle = '';
    if (productUrl) {
      const match = productUrl.match(/\/products\/([^\/\?]+)/);
      if (match) {
        handle = match[1];
      }
    }
    
    // variantIdがある場合、URLにvariantパラメータを追加して正しいバリアントが選択されるようにする
    // ただし、これは表示用URLのみ（リンク用）
    let displayUrl = productUrl;
    if (variantId && productUrl) {
      try {
        const url = new URL(productUrl, window.location.origin);
        // variantIdから数値部分を抽出
        const numericVariantId = typeof variantId === 'string' 
          ? variantId.replace(/[^0-9]/g, '') 
          : variantId.toString();
        if (numericVariantId) {
          url.searchParams.set('variant', numericVariantId);
          displayUrl = url.pathname + url.search;
        }
      } catch (e) {
        // URL解析に失敗した場合は元のURLを使用
        console.warn('URL解析エラー:', e);
      }
    }

    // 千の区切り文字で価格をフォーマット
    const priceNum = typeof price === 'number' ? price : parseFloat(price) || 0;
    const formattedPrice = priceNum.toLocaleString('ja-JP');

    // metaDataからロケーションを取得、またはSwymデータにフォールバック
    const location = metaData?.location || null;
    const store_name = metaData?.store_name || null;
    const locationText = formatLocation(location, store_name);

    // 売り切れステータスに基づいてボタンのテキストとクラスを設定
    let buttonText = '';
    let buttonClass = '';
    let buttonDisabled = '';

    if (isSoldOut == 'soldout') {
        buttonText = 'SOLD OUT';
        buttonClass = 'btn_add_to_cart sold_out';
        buttonDisabled = 'disabled';
    } else if (isSoldOut == 'preorder') {
        buttonText = '予約注文';
        buttonClass = 'btn_add_to_cart pre_order';
        buttonDisabled = '';
    } else {
        buttonText = 'カートに入れる';
        buttonClass = 'btn_add_to_cart';
        buttonDisabled = '';
    }

    return `
      <li class="prod_card">
        <a href="${displayUrl || '#'}">
          <div class="thumb">
            <img
              loading="lazy"
              src="${imageUrl}"
              alt="${title}"
              width="230"
              height="230"
              onerror="this.src='${imageUrl || '/assets/no-image.webp'}'">
          </div>
          ${locationText ? `<span class="location">${locationText}</span>` : '<span class="location"></span>'}
          <div class="txt_area">
            <h3>${title}</h3>
            <span class="price">¥${formattedPrice}</span>
          </div>
        </a>
        <div class="wishlist_actions">
          <button class="${buttonClass}" data-variant-id="${variantId}" data-handle="${handle}" data-original-text="${buttonText}" ${buttonDisabled}>${buttonText}</button>
          <button class="btn_remove_wishlist" data-lid="${lid}" data-epi="${variantId}" data-empi="${productId}" data-du="${originalProductUrl}" data-original-text="削除する">削除する</button>
        </div>
      </li>
    `;
  }

  // ウィッシュリスト商品を読み込んで表示
  function loadWishlistProducts() {
    const $container = $('#wishlist_products');
    const $emptyMsg = $('#wishlist_empty');

    // 読み込み状態を表示
    $container.html('<li class="loading">読み込み中...</li>').show();
    $emptyMsg.hide();

    // ステップ1: lidを取得するためにユーザーのウィッシュリストを取得
    fetchUserWishlists(
      // onSuccessコールバック
      function(lid) {
        if (!lid) {
          $container.hide();
          $emptyMsg.show();
          return;
        }

        // ステップ2: lidを使用してリストコンテンツを取得
        fetchListContents(lid,
          // onSuccessコールバック
          async function(listItems) {
            if (!listItems || listItems.length === 0) {
              $container.hide();
              $emptyMsg.show();
              return;
            }

            // ステップ3: 商品メタ情報を取得して商品をレンダリング（プログレッシブレンダリング）
            // ローディング状態を維持（データが取得されるまで表示）
            $container.html('<li class="loading">読み込み中...</li>').show();
            $emptyMsg.hide();

            // バッチサイズを制限してAPI呼び出しを最適化（一度に5つずつ処理）
            const BATCH_SIZE = 5;
            let processedCount = 0;
            let hasRenderedFirstBatch = false;

            const processBatch = async (startIndex, isFirstBatch = false) => {
              const endIndex = Math.min(startIndex + BATCH_SIZE, listItems.length);
              const batch = listItems.slice(startIndex, endIndex);
              
              const batchPromises = batch.map(async (swymItem, batchIndex) => {
                const globalIndex = startIndex + batchIndex;
                const productId = swymItem.empi || swymItem.product?.empi || '';
                const variantId = swymItem.epi || swymItem.product?.epi || '';
                const productUrl = swymItem.du || swymItem['raw-du'] || swymItem.product?.du || '';
                
                // URLから商品ハンドルを解析
                let handle = '';
                if (productUrl) {
                  const match = productUrl.match(/\/products\/([^\/\?]+)/);
                  if (match) {
                    handle = match[1];
                  }
                }
                
                // 並列でデータを取得
                const [metaData, stockStatus, latestPrice] = await Promise.all([
                  productId ? getProductMeta(productId) : Promise.resolve({ location: null, store_name: null }),
                  variantId && handle ? checkVariantAvailability(variantId, handle) : Promise.resolve('available'),
                  variantId && handle ? fetchVariantPrice(variantId, handle) : Promise.resolve(null)
                ]);
                
                return { index: globalIndex, swymItem, metaData, stockStatus, latestPrice };
              });

              const batchResults = await Promise.all(batchPromises);
              
              // 最初のバッチの場合、商品カードをレンダリング（ローディングを削除）
              if (isFirstBatch) {
                const firstBatchCards = batchResults.map(({ swymItem, metaData, stockStatus, latestPrice }) => {
                  if (!swymItem.lid) {
                    swymItem.lid = lid;
                  }
                  return renderProductCard(swymItem, metaData, stockStatus, latestPrice);
                });
                $container.empty().html(firstBatchCards.join(''));
                hasRenderedFirstBatch = true;
              } else {
                // 後続のバッチの場合、各商品を個別に追加
                batchResults.forEach(({ index, swymItem, metaData, stockStatus, latestPrice }) => {
                  if (!swymItem.lid) {
                    swymItem.lid = lid;
                  }
                  
                  // 商品カードを追加
                  const card = renderProductCard(swymItem, metaData, stockStatus, latestPrice);
                  $container.append(card);
                });
              }

              processedCount += batch.length;
              
              // 次のバッチを処理
              if (endIndex < listItems.length) {
                // 次のバッチを少し遅延させてUIをブロックしないようにする
                setTimeout(() => processBatch(endIndex, false), 50);
              }
            };

            // 最初のバッチを開始（価格を含めてレンダリング）
            processBatch(0, true);
          },
          // onErrorコールバック
          function(error) {
            console.error('リストコンテンツの取得エラー:', error);
            $container.hide();
            $emptyMsg.show();
          }
        );
      },
      // onErrorコールバック
      function(error) {
        console.error('ユーザーのウィッシュリストの取得エラー:', error);
        $container.hide();
        $emptyMsg.show();
      }
    );
  }

  // カートに追加を処理
  $(document).on('click', '.btn_add_to_cart:not(.sold_out)', function() {
    const $btn = $(this);
    
    // 売り切れの場合はクリックを許可しない
    if ($btn.hasClass('sold_out') || $btn.prop('disabled')) {
      return;
    }
    
    const variantId = $btn.data('variant-id');
    const handle = $btn.data('handle');
    
    if (!variantId) {
      // バリアントIDがない場合、ハンドルで商品を取得してデフォルトバリアントを取得
      if (handle) {
        fetchProductDetails(handle).then(product => {
          if (product && product.variants && product.variants.length > 0) {
            const defaultVariantId = product.variants[0].id;
            addToCart(defaultVariantId, $btn);
          } else {
            alert('商品を選択してください。');
          }
        });
      } else {
        alert('商品を選択してください。');
      }
      return;
    }

    addToCart(variantId, $btn);
  });

  // 元のボタンテキストを取得するヘルパー関数
  function getOriginalText($btn) {
    return $btn.data('original-text') || $btn.text();
  }

  // カートに追加するヘルパー関数
  function addToCart(variantId, $btn) {
    const originalText = getOriginalText($btn);
    const loadingText = $btn.data('loading-text') || '追加中...';
    
    $btn.prop('disabled', true).text(loadingText);

    if (typeof Cart !== 'undefined' && Cart.addToCart) {
      Cart.addToCart(variantId, 1, '').then(() => {
        if (typeof updateCartBadge === 'function') {
          updateCartBadge();
        }
        $btn.prop('disabled', false).text(originalText);
        if (typeof handleModal === 'function') {
          handleModal('商品をカートに入れました。');
        } else {
          alert('商品をカートに入れました。');
        }
      }).catch(err => {
        console.error('カートへの追加エラー:', err);
        $btn.prop('disabled', false).text(originalText);
        alert('商品をカートに入れられませんでした。');
      });
    } else {
      $btn.prop('disabled', false).text(originalText);
      alert('カート機能が利用できません。');
    }
  }

  // ウィッシュリストから削除を処理
  $(document).on('click', '.btn_remove_wishlist', function() {
    const $btn = $(this);
    const lid = $btn.data('lid');
    const epi = $btn.data('epi');
    const empi = $btn.data('empi');
    const du = $btn.data('du');

    // デバッグ用ログ
    console.log('削除ボタンクリック:', { lid, epi, empi, du });

    if (!lid || !epi || !empi || !du) {
      console.error('削除に必要なデータが不足しています:', { lid, epi, empi, du });
      alert('削除できませんでした。');
      return;
    }

    const originalText = getOriginalText($btn);
    const loadingText = $btn.data('loading-text') || '削除中...';
    
    $btn.prop('disabled', true).text(loadingText);

    // Swym APIを使用してリストからアイテムを削除
    if (typeof _swat !== 'undefined' && _swat.deleteFromList) {
      // 削除する商品を定義（Swym APIの形式に合わせる）
      const product = {
        epi: epi,  // リストIDごとの一意のバリアントID
        empi: empi, // 商品ID
        du: du // 商品URL（元のURL、variantパラメータなし）
      };

      console.log('Swym deleteFromList呼び出し:', { lid, product });

      const onSuccess = function(deletedProduct) {
        console.log('削除成功:', deletedProduct);
        $btn.closest('.prod_card').fadeOut(300, function() {
          $(this).remove();
          const remainingItems = $('#wishlist_products .prod_card').length;
          if (remainingItems === 0) {
            $('#wishlist_products').hide();
            $('#wishlist_empty').show();
          }
        });
      };
      
      const onError = function(error) {
        console.error('商品の削除エラー:', error);
        $btn.prop('disabled', false).text(originalText);
        alert('削除できませんでした。');
      };
      
      // lid、商品オブジェクト、コールバックでdeleteFromListを呼び出し
      try {
        _swat.deleteFromList(lid, product, onSuccess, onError);
      } catch (e) {
        console.error('deleteFromList呼び出しエラー:', e);
        $btn.prop('disabled', false).text(originalText);
        alert('削除する機能の呼び出しに失敗しました。');
      }
    } else {
      console.error('Swym deleteFromList APIが利用できません', { _swat: typeof _swat, deleteFromList: typeof _swat?.deleteFromList });
      $btn.prop('disabled', false).text(originalText);
      alert('削除する機能が利用できません。Swym APIが読み込まれていません。');
    }
  });

  // ページ読み込み時にウィッシュリストを初期化
  $(document).ready(function() {
    waitForSwym(() => {
      loadWishlistProducts();
    });
  });
})(jQuery);
